import { render } from "./AppShell.3.vue?vue&type=template&id=4f36a0d7&scoped=true&ts=true"
import script from "./AppShell.3.vue?vue&type=script&lang=ts"
export * from "./AppShell.3.vue?vue&type=script&lang=ts"

import "./styles/DFStyle_SiteIndex_Template.less?vue&type=style&index=0&lang=less&external"
import "./AppShell.3.vue?vue&type=style&index=1&id=4f36a0d7&lang=css"
import "./AppShell.3.vue?vue&type=style&index=2&id=4f36a0d7&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f36a0d7"]])

export default __exports__